/**
 * ThemeProvider component - provides consistent theming across the unified application
 *
 * Wraps the application with Fluent UI theme context and applies global styles.
 * Ensures consistent visual design across all route modules.
 *
 * Validates: Requirements 4.1, 4.3
 */

import React from 'react';
import { ThemeProvider as FluentThemeProvider, initializeIcons } from '@fluentui/react';
import { AppTheme } from './theme';
import './global.css';

// Initialize Fluent UI icons
initializeIcons();

export interface ThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Application theme provider
 *
 * Provides Fluent UI theme context to all child components and applies
 * global CSS styles. This ensures consistent theming across all route modules.
 */
export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  return (
    <FluentThemeProvider theme={AppTheme}>
      {children}
    </FluentThemeProvider>
  );
};
